export default "__VITE_ASSET__CT7e4gDB__"